import { render } from "./ForbrugFilters.vue?vue&type=template&id=06b53e0e&scoped=true"
import script from "./ForbrugFilters.vue?vue&type=script&lang=js"
export * from "./ForbrugFilters.vue?vue&type=script&lang=js"

import "./ForbrugFilters.vue?vue&type=style&index=0&id=06b53e0e&scoped=true&lang=css"

import exportComponent from "C:\\MartinRud-CloudRoot\\Firma\\Code\\PHP\\byensegenbil.dk\\byensegenbil.dk-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b53e0e"]])

export default __exports__